// Import Packages
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useRecoilState, useRecoilValue, useSetRecoilState } from "recoil";

// Import Material UI
import FormControl from "@material-ui/core/FormControl";
import IconButton from "@material-ui/core/IconButton";
import AddCircleOutlineIcon from "@material-ui/icons/AddCircleOutline";
import { withStyles } from "@material-ui/core/styles";
import InputBase from "@material-ui/core/InputBase";
import FileCopyOutlinedIcon from '@material-ui/icons/FileCopyOutlined';
import { Autocomplete } from "@material-ui/lab";
import { TextField, Checkbox } from "@material-ui/core";
import CheckBoxOutlineBlankIcon from '@material-ui/icons/CheckBoxOutlineBlank';
import CheckBoxIcon from '@material-ui/icons/CheckBox';
import { Tooltip } from '@material-ui/core';

// Import Recoil
import { activeAutom, changedFields, initialActions, saveAvailable, alertState } from "../../../recoil-store/recoil-state";

// Import CSS
import './VariablePicker.css';
import { CheckIfFlowUpdated } from "../../../helpers/helper";

const BootstrapInput = withStyles((theme) => ({
    root: {
        "label + &": {
            marginTop: theme.spacing(3),
        },
        input: {
            position: 'relative',
            paddingLeft: 5,
            // border: "0.5px solid #D5D5D5"
            // Use the system font instead of the default Roboto font.

        },
    }
}))(InputBase);

// Import Icons
const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;

function VariablePicker({
    action,
    inputName,
    variables,
    setOpenVariable,
    isRequired,
    filter,
    remove,
    condition,
    inputIndex,
    variableRender,
    showVariablePicker,
    isNull = false,
    inputName2,
    index,
    inputName3,
    system,
    disabled,
    setField,
    styles,
    handleStopScroll,
    handleControlScroll,
    isOutput,
    hideRequired,
    multiSelect
}) {
    const [filteredVariables, setFilteredVariables] = useState([]);
    const [variable, setVariable] = useState(multiSelect ? [] : '');
    const [automDetail, setAutomDetail] = useRecoilState(activeAutom);
    const initialActionsData = useRecoilValue(initialActions);
    const setSaveAvailable = useSetRecoilState(saveAvailable);
    const setChangeFields = useSetRecoilState(changedFields);
    const changedFieldsState = useRecoilValue(changedFields);
    const setAlert = useSetRecoilState(alertState);

    let lsInputName = localStorage.getItem("inputName");
    let variableName = localStorage.getItem("variablename");
    const { t } = useTranslation();
    useEffect(() => {
        if (inputName) {
            let field, oldValue, newValue;
            localStorage.removeItem("inputName");
            if (!action.fields[inputName]) {
                action.fields[inputName] = { value: multiSelect ? [] : '', type: 'VARIABLEPICKER', isRequired, variableType: '' };
            } else {
                if (!isNull) {
                    if (variableName !== null && lsInputName === inputName) {
                        let filterType = filterVariablesTypes(variableName);
                        if (!filter || (filterType && filterType.length && filterType[0].type === filter)) {
                            newValue = variableName;
                            field = initialActionsData[action.id]?.fields[inputName];
                            oldValue = !field ? undefined : field.value;
                            action.fields[inputName].variableType = (filterType !== null && filterType !== undefined) ? filterType[0].type : '';
                            if (multiSelect) {
                                let v = action.fields[inputName].value
                                if (Array.isArray(v)) {
                                    v.push(variableName);
                                    action.fields[inputName].value = v;
                                    setVariable(v);
                                } else {
                                    action.fields[inputName].value = [variableName];
                                    setVariable([variableName]);
                                }
                            } else {
                                setVariable(variableName)
                                action.fields[inputName].value = variableName;
                            }
                            CheckIfFlowUpdated(inputName, action, oldValue, newValue, setSaveAvailable, setChangeFields, changedFieldsState);
                        } else {
                            setAlert(alert => ({ ...alert, show: true, message: t("GENERAL.VARIABLE-NOT-SELECTED"), severity: 'warning' }))
                        }

                    } else {
                        // eski versiondan gelen ##xVariable## değerini düzenlemk için yazıldı.
                        if (!action.fields[inputName].value?.includes('##')) {
                            setVariable(action.fields[inputName].value);
                        } else {
                            // # ifadeleri kaldırılıyor.
                            const searchRegExp = /#/gi;
                            let v = action.fields[inputName].value.replace(searchRegExp, "");
                            action.fields[inputName].value = v;
                            setVariable(v);
                        }

                    }
                    localStorage.removeItem("variablename");

                } else {
                    if (variableName !== null && lsInputName === inputName) {
                        let filterType = filterVariablesTypes(variableName);
                        if (!filter || (filterType && filterType.length && filterType[0].type === filter)) {
                            action.fields[inputName].variableType = (filterType !== null && filterType !== undefined) ? filterType[0].type : '';
                            if (multiSelect) {
                                let v = action.fields[inputName].value
                                if (Array.isArray(v)) {
                                    v.push(variableName);
                                    action.fields[inputName].value = v;
                                    setVariable(v);
                                } else {
                                    action.fields[inputName].value = [variableName];
                                    setVariable([variableName]);
                                }
                            } else {
                                setVariable(variableName)
                                action.fields[inputName].value = variableName;
                            }
                        } else {
                            setAlert(alert => ({ ...alert, show: true, message: t("GENERAL.VARIABLE-NOT-SELECTED"), severity: 'warning' }))
                        }                        
                    } else {
                        if (action.fields[inputName2]) {
                            setVariable(action.fields[inputName2].value[index][inputName3]);
                        } else {
                            setVariable("");
                        }
                    }
                    localStorage.removeItem("variablename");

                }
            }
        } else if (inputIndex >= 0 && action) {
            if (!action[inputIndex]) {
                action[inputIndex] = { value: '', type: 'VARIABLEPICKER', isRequired, variableType: '' };
            } else {
                if (!isNull) {
                    if (variableName !== null && lsInputName === inputName) {
                        let filterType = filterVariablesTypes(variableName);
                        if (!filter || (filterType && filterType.length && filterType[0].type === filter)) {
                            action[inputIndex].variableType = (filterType !== null && filterType !== undefined) ? filterType[0].type : '';
                            setVariable(variableName)
                            action[inputIndex].value = variableName;
                        } else {
                            setAlert(alert => ({ ...alert, show: true, message: t("GENERAL.VARIABLE-NOT-SELECTED"), severity: 'warning' }))
                        }
                    } else {
                        setVariable(action[inputIndex].value);
                    }
                    localStorage.removeItem("variablename");

                } else {
                    if (variableName !== null && lsInputName === inputName) {
                        let filterType = filterVariablesTypes(variableName);
                        if (!filter || (filterType && filterType.length && filterType[0].type === filter)) {
                            action[inputIndex].variableType = (filterType !== null && filterType !== undefined) ? filterType[0].type : '';
                            setVariable(variableName)
                            action[inputIndex].value = variableName;
                        } else {
                            setAlert(alert => ({ ...alert, show: true, message: t("GENERAL.VARIABLE-NOT-SELECTED"), severity: 'warning' }))
                        }
                    } else {
                        if (action.fields[inputName2]) {
                            setVariable(action.fields[inputName2].value[index][inputName3]);
                        } else {
                            setVariable("");
                        }
                    }
                    localStorage.removeItem("variablename");
                }
            }
        }
        if (filter) {
            setFilteredVariables(Object.keys(variables).length > 0 ? variables.filter((x) => x.type === filter) : []);
        } else if (remove) {
            setFilteredVariables(Object.keys(variables).length > 0 ? variables?.filter((x) => !remove.includes(x.type)) : []);
        } else if (system) {
            setFilteredVariables(Object.keys(variables).length > 0 ? variables?.filter(x => x.system_variable !== 1) : []);
        } else {
            setFilteredVariables(variables);
        }
    }, [action, variables, filter]);

    function filterVariablesTypes(value) {
        return variables && variables.filter(v => v.name.toLowerCase() === value.toLowerCase())
    }

    const handleSetChange = (eventValue) => {
        if (multiSelect) {
            eventValue = eventValue.map(x => x.name ? x.name : x);
        } else {
            eventValue = eventValue && eventValue.name ? eventValue.name : '';
        }
        let field;
        let newValue;
        let oldValue;
        //filtered variables
        let filterType = filterVariablesTypes(Array.isArray(eventValue) ? (eventValue.length ? eventValue[0] : '') : eventValue);
        setVariable(eventValue);
        if (inputName) {
            newValue = eventValue;
            field = initialActionsData[action.id]?.fields[inputName];
            oldValue = !field ? undefined : field.value;
            action.fields[inputName].variableType = (filterType[0] !== null && filterType[0] !== undefined) ? filterType[0].type : '';
            action.fields[inputName].value = eventValue;
            if (setField) {
                setField(inputName, { value: eventValue, variableType: action.fields[inputName].variableType });
            }
            CheckIfFlowUpdated(inputName, action, oldValue, newValue, setSaveAvailable, setChangeFields, changedFieldsState);
        } else if (inputIndex >= 0) {
            action[inputIndex].variableType = filterType[0] !== undefined ? filterType[0].type : '';
            action[inputIndex].value = eventValue;
        }
        if (isOutput) {
            let copyItems = JSON.parse(JSON.stringify(automDetail.items))

            findAndUpdateItem(copyItems)
            setAutomDetail({
                ...automDetail,
                items: copyItems
            })
        }
    }

    const findAndUpdateItem = (items) => {
        items.forEach(item => {
            if (item.item_id === action.item_id) {
                item.fields = JSON.parse(JSON.stringify(action.fields))
                return;
            } else if (item.children) {
                findAndUpdateItem(item.children)
            }
        })
    }

    const handleOpen = () => {
        setOpenVariable(true);
        localStorage.setItem("inputName", inputName);
    }

    return (
        <>
            {isRequired === true && !hideRequired &&
                <small style={{ color: '#D75E5E' }}>&nbsp; {t('FLOW-MESSAGES.LIBRARY.GENERAL.REQUIRED')}</small>}
            <div className="items-center">
                <FormControl variant="outlined" fullWidth style={{ width: "90%" }} disabled={disabled}>                    
                    <Autocomplete
                        style={{ borderRadius: 2, ...styles }}
                        multiple={!!multiSelect}
                        disableCloseOnSelect={!!multiSelect}
                        onChange={(event, data, reason) => handleSetChange(data)} // handleSetChange(data && data.name ? data.name : "")}
                        value={variable}
                        id="combo-box"
                        size="small"
                        disabled={disabled}
                        renderOption={multiSelect ? (option, { selected }) => (
                            <React.Fragment>
                                <Checkbox
                                    icon={icon}
                                    checkedIcon={checkedIcon}
                                    style={{ marginRight: 8 }}
                                    checked={selected}
                                />
                                {option.display_name ? option.display_name : option.name}
                            </React.Fragment>
                        ) : undefined}
                        options={filteredVariables?.length > 0 && JSON.stringify(filteredVariables[0]) !== '{}' ? filteredVariables : []}
                        getOptionLabel={(item) => {
                            if (item.name) {
                                return item.display_name ? item.display_name : item.name
                            }
                            return item
                        }}
                        getOptionSelected={(option, value) => Array.isArray(value) ? value.find(x => x === option.name) : option.name === value}
                        renderInput={
                            (params) =>
                                <Tooltip title={variable || ""} placement="top">
                                    <TextField
                                        {...params}
                                        variant="outlined"
                                        className="output-dropdown"
                                    />
                                </Tooltip>
                        }
                        onFocus={handleStopScroll && handleStopScroll}
                        onBlur={handleControlScroll && handleControlScroll}
                    />
                </FormControl>

                {
                    <span className="variable-copy-icon-container">
                        <FileCopyOutlinedIcon className="variable-copy-icon" onClick={() => navigator.clipboard.writeText(variable ? `##${variable}##` : '')} />
                    </span>
                }
                {
                    (showVariablePicker === undefined || showVariablePicker) &&
                    <IconButton disabled={disabled} style={{ padding: 0 }} onClick={() => handleOpen()}>
                        <AddCircleOutlineIcon style={{ paddingLeft: 5, color: "#8C90A2" }} />
                    </IconButton>
                }
            </div>
        </>
    )
}

export default VariablePicker;
